<ion-content class="bg-color ion-content add-category">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <mat-card>
          <mat-card-title class="mc-title">
            <span class="org-header">Category</span>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <form [formGroup]="addCategoryForm" (ngSubmit)="onSubmit()">
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>Category</mat-label>
                    <input type="text" formControlName="category" matInput placeholder="Category" required>
                  </mat-form-field>
                </div>
                <div class="btn-signup-grid">
                  <button mat-raised-button class="btn" routerLink="/baseapp/category">Cancel</button>
                  <button mat-raised-button type="submit" class="btn btn-signup">Add</button>
                </div>
              </form>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>
